
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import AIEvaluation from './components/AIEvaluation';
import DailyMotivation from './components/DailyMotivation';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Features />
      <AIEvaluation />
      <DailyMotivation />
      <Contact />
      <Footer />
    </div>
  );
}
